import { useEffect, useState } from "react";
import { SelectorProcessTypeConstants } from "./Componentes/SelectorProcessTypeConstants";
import { PrintJson } from "../../theme/Component/PrintJson";
import useModal, { MODAL_LG, MODAL_md } from "../../theme/Component/hooks/useModal";
import { Modal } from "../../theme/Component/Modal";
import { ContractService } from "../../../core/services/ContractService";
import { _single } from "../../../core/services/dataBean/EntityCatalog";
import { BasicSwitch } from "../../theme/Component/BasicSwitch";

interface Props {
    config: any;
    onChange: any;
}
export const DocumentTRDEditor = ({ config, onChange }: Props) => {


    const service = new ContractService();

    const [document, setDocument] = useState<any>({
        IDProcessType: 0,
        IDDocument: 0,
        DocumentName: '',
        Multiple: false
    });
    const [lista, setLista] = useState<any>([]);
    const modal = useModal("Documentos", MODAL_LG);

    useEffect(() => {
        console.log(config);

        if (config) {
            try {
                setDocument(JSON.parse(config));
                console.log(JSON.parse(config));

            } catch (error) {
            }
        }
    }, [])

    useEffect(() => {
        getHiringModalityDocumentRender();
    }, [document.IDProcessType])

    useEffect(() => {
        if (document.IDDocument) {
            onChange({
                Strangulated: JSON.stringify(document),
                Obje: document
            });
        }
    }, [document])

    const getHiringModalityDocumentRender = () => {

        let filter: any = {};
        if (document.IDProcessType > 0) {
            filter.ProcessType = document.IDProcessType
        }
        _single.spinner(true);
        service.getHiringModalityDocumentRender(null, null, filter).subscribe(
            (resp: any) => {


                if (resp.DataBeanProperties.ObjectValue.DataBeanProperties.List) {
                    setLista(resp.DataBeanProperties.ObjectValue.DataBeanProperties.List);
                    let lis = resp.DataBeanProperties.ObjectValue.DataBeanProperties.List;
                    if (lis.length > 0) {


                        putDocument(lis[0].DataBeanProperties.IDHiringModalityDocument);
                    }
                } else {
                    setLista([])
                }
                _single.spinner(false);

            }
        );
    }

    const putDocument = (idDoc: any) => {
        console.log(idDoc);

        lista.forEach(element => {
            if (element.DataBeanProperties.IDHiringModalityDocument == idDoc) {
                setDocument({ ...document, "DocumentName": element.DataBeanProperties.Name, "IDDocument": element.DataBeanProperties.IDHiringModalityDocument });
                console.log(element.DataBeanProperties);

            }
        });
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <label>Documento</label>
                <input type="text" name="doc" className="form-control" value={document.DocumentName} readOnly onClick={() => { modal.open() }} />

            </div>

            <div className="col-md-12">
                <Modal modal={modal.modal} updateModal={modal.setModal}>
                    <div className="row">
                        <div className="col-md-6">
                            <SelectorProcessTypeConstants idSelector={document.IDProcessType} onChange={(e) => { setDocument({ ...document, "IDProcessType": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <label>Documento</label>
                            <select name="docid" className="form-control" value={document.IDDocument} onChange={(e) => { putDocument(e.target.value) }}>
                                {lista.map((item: any, index: any) => {
                                    return (
                                        <option value={item.DataBeanProperties.IDHiringModalityDocument}>{item.DataBeanProperties.Name}</option>
                                    )
                                })

                                }
                            </select>
                        </div>
                        <div className="col-md-6">
                            <BasicSwitch label="Documento multiple" estado={document.Multiple ?? false} eventChange={(e) => { setDocument({ ...document, "Multiple": e }) }} />
                        </div>
                    </div>
                </Modal>
            </div>

        </div>
    )
}
